import React from "react";

import classes from "./Map.module.css";

const Map = () => {
  return (
    <div className={classes["wrapper"]}>
      <iframe
        className={classes["map"]}
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1011.0370118974267!2d69.19120349564975!3d41.355503127623855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38ae8e9d708779ff%3A0xb44849b65e5e67b4!2zMjQ5LdGI0LrQvtC70LAg0KjQutC-0LvQsA!5e0!3m2!1sru!2s!4v1684247283823!5m2!1sru!2s"
        width="100%"
        height="450"
        style={{ border: "none" }}
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default Map;
